import type { AutoshipCustomerApiResponse } from '@libs/common-types';

export function isCustomerFirstAutoshipEligible(autoshipData: AutoshipCustomerApiResponse | undefined): boolean {
    return autoshipData?.data?.isFirstAutoshipEligible !== false;
}
